import React, { useContext } from 'react'
import classNames from 'classnames'
import Button from '../button'
import { useTranslations } from '../hooks'
import { ModalDialogContext } from './modal-dialog-context'

type PropsButtons = {
  showCancel?: boolean
  showConfirm?: boolean
  cancelText?: string
  confirmText?: string
  onCancel?: () => void
  onConfirm?: () => void
  closeOnConfirm?: boolean
  disableConfirm?: boolean
  submitOnConfirm?: boolean
  children?: never
}

type PropsChildren = {
  showCancel?: never
  showConfirm?: never
  cancelText?: never
  confirmText?: never
  onCancel?: never
  onConfirm?: never
  closeOnConfirm?: never
  disableConfirm?: never
  submitOnConfirm?: never
  children: React.ReactNode
}

type Props = (PropsButtons | PropsChildren) & {
  className?: string
}

export const ModalDialogFooter = ({
  showCancel,
  showConfirm,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  closeOnConfirm,
  disableConfirm,
  submitOnConfirm,
  children,
  className,
}: Props) => {
  const { translate } = useTranslations()
  const { size, handleClose } = useContext(ModalDialogContext)

  const buttonRowClass = `d-flex u-w-100 ${size === 'sm' ? '' : 'justify-content-end'}`
  const buttonClass = `c-btn--block ${size === 'sm' ? '' : 'c-btn-md--contain'}`

  return (
    <div className={classNames('c-dialog__footer', className)}>
      {children ? <>{children}</> : null}
      {showCancel || showConfirm ? (
        <div className={buttonRowClass}>
          {showCancel ? (
            <Button
              onClick={onCancel ?? handleClose}
              text={cancelText || translate('Cancel')}
              className={classNames('u-mb-0', buttonClass, { 'u-mr-16': showConfirm })}
              type="button"
              block={true}
            />
          ) : null}
          {showConfirm ? (
            <Button
              onClick={closeOnConfirm ? handleClose : onConfirm}
              text={confirmText || 'OK'}
              className={classNames('u-mb-0', buttonClass)}
              type={submitOnConfirm ? 'submit' : 'button'}
              block={true}
              primary={true}
              disabled={disableConfirm}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
